import React from 'react';
import Layout from './Layout';

function MainLayout({ children }) {
  return <Layout>{children}</Layout>;
}

export default MainLayout;
